var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLowIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7017 9.34315L8.22017 15.7071C7.82243 16.0976 7.17757 16.0976 6.77983 15.7071L0.298303 9.34314C-0.0994352 8.95262 -0.0994352 8.31946 0.298303 7.92893C0.696042 7.53841 1.3409 7.53841 1.73864 7.92893L6.48153 12.5858L6.48153 -3.72354e-07L8.51847 -2.83317e-07L8.51847 12.5858L13.2614 7.92893C13.6591 7.53841 14.304 7.53841 14.7017 7.92893C15.0994 8.31946 15.0994 8.95262 14.7017 9.34315Z",
    fill: "#C65656"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowIcon);
export default __webpack_public_path__ + "static/media/lowIcon.2b2aad109633c8f2d2d3130fcfcde7da.svg";
export { ForwardRef as ReactComponent };